import React from "react";
import { string } from "prop-types";
import "./event-info-label.m.css";

export const EventInfoLabel = ({ children }) => {
  return (
    <div styleName="event-info-label">
      <p>{children}</p>
    </div>
  );
};

EventInfoLabel.propTypes = {
  children: string.isRequired,
};